var VISMA_DOC_STATUSES = {
  "new": 'new',
  pending: 'pending',
  signed: 'signed',
  deleted: 'deleted',
  cancelled: 'cancelled'
};
export default VISMA_DOC_STATUSES;
export var VISMA_INVITATION_STATUSES = {
  waitingForSend: 'waiting-for-send',
  sending: 'sending',
  "new": 'new',
  opened: 'opened',
  signed: 'signed',
  cancelled: 'cancelled'
};